import log, { LogLevelDesc } from "loglevel";

class LogServiceController {
	log = log;

	constructor() {
		const originalFactory = log.methodFactory;
		log.methodFactory = function (methodName, logLevel, loggerName) {
			const rawMethod = originalFactory(methodName, logLevel, loggerName);

			return function () {
				let messages = [`[${new Date().toISOString()}] - DOCK`];

				for (const argument of arguments) {
					messages.push(argument);
				}

				rawMethod.apply(undefined, messages);
			};
		};

		// Apply override log function
		log.setLevel(log.getLevel());
	}

	/**
	 * Returns true if valid log level
	 * @param inputLevel
	 */
	isOfTypeLogLevelDesc(inputLevel: string | number): inputLevel is LogLevelDesc {
		return ["info", "trace", "warn", "error", "debug", "silent", 0, 1, 2, 3, 4, 5].includes(inputLevel);
	}
}

export const LogService = new LogServiceController();
